import { ReactNode } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { TSeverity, SEVERITY_COLOR, SEVERITY_BG } from "../../utils/MetricThresholds";

interface IKpiCardProps {
  title: string;
  value: string;
  // Unidad chica al lado del valor (ej. "días").
  unit?: string;
  severity?: TSeverity;
  // Colorea el valor con el color de la severidad (Figma: número ámbar/rojo en
  // las tarjetas de alerta). Sin esto, el valor va en color primario.
  colorValue?: boolean;
  // Ícono opcional junto al título (ej. warning/error en las tarjetas de SLA).
  icon?: ReactNode;
  subtitle?: string;
  onClick?: () => void;
}

const KpiCard = ({
  title,
  value,
  unit,
  severity,
  colorValue = false,
  icon,
  subtitle,
  onClick,
}: IKpiCardProps) => {
  // Fondo tenue + borde suave del mismo tono (no un borde grueso saturado).
  const cardSx = {
    height: "100%",
    cursor: onClick ? "pointer" : "default",
    border: severity ? `1px solid ${SEVERITY_COLOR[severity]}55` : "1px solid #e0e0e0",
    backgroundColor: severity ? SEVERITY_BG[severity] : "#fff",
    boxShadow: "none",
    "&:hover": onClick ? { boxShadow: 3 } : {},
  };

  const valueColor =
    colorValue && severity ? SEVERITY_COLOR[severity] : "text.primary";

  return (
    <Card sx={cardSx} onClick={onClick}>
      <CardContent sx={{ padding: "16px !important" }}>
        <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
          {icon}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textTransform: "uppercase", fontSize: "0.75rem", letterSpacing: 0.3 }}
          >
            {title}
          </Typography>
        </Box>
        <Box display="flex" alignItems="baseline" gap={0.5}>
          <Typography variant="h5" fontWeight={700} color={valueColor}>
            {value}
          </Typography>
          {unit && (
            <Typography variant="body2" color="text.secondary">
              {unit}
            </Typography>
          )}
        </Box>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default KpiCard;
